/**
 * <home-reviews>: kapt lange reviews op de homepage af op vijf regels, met "Lees verder"
 * erachter (handoff §3.9: een afgekapte review krijgt altijd die knop, zodat het
 * kritische deel nooit stilletjes wegvalt).
 *
 * Eerst afkappen, dan meten: past de tekst al, dan gaat de afkapping er weer af en
 * komt er geen knop. Zonder JS staat elke review er heel.
 */
class HomeReviews extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const more = this.dataset.more || '';
    const less = this.dataset.less || '';

    for (const text of this.querySelectorAll('[data-review-text]')) {
      const button = text.nextElementSibling;
      if (!(text instanceof HTMLElement) || !(button instanceof HTMLButtonElement)) continue;

      text.setAttribute('data-clamped', '');
      if (text.scrollHeight <= text.clientHeight + 1) {
        text.removeAttribute('data-clamped');
        continue;
      }

      button.hidden = false;
      button.addEventListener(
        'click',
        () => {
          const expanded = text.toggleAttribute('data-clamped') === false;
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? less : more;
        },
        { signal: this.#controller.signal }
      );
    }
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('home-reviews')) {
  customElements.define('home-reviews', HomeReviews);
}
